import {
  Badge,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Spinner,
} from '@avila-roffe/components-web';
import { Mail, MoreHorizontal, UserCheck } from 'lucide-react';
import type { DirectoryUser } from '../TenantSettingsService';

function directoryInitials(user: DirectoryUser): string {
  const first = user.givenName?.[0] ?? '';
  const last = user.surname?.[0] ?? '';
  if (first || last) return (first + last).toUpperCase();
  return user.displayName?.[0]?.toUpperCase() ?? '?';
}

export interface IdpUserCardProps {
  user: DirectoryUser;
  onInvite: () => void;
  onAdd?: () => void;
  isPending?: boolean;
}

export function IdpUserCard({ user, onInvite, onAdd, isPending = false }: IdpUserCardProps) {
  const inits = directoryInitials(user);
  return (
    <div className="flex items-center gap-3 rounded-xl border border-dashed bg-card/60 p-3">
      <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-muted text-sm font-medium text-muted-foreground select-none">
        {inits}
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-foreground">{user.displayName}</p>
        <p className="truncate font-mono text-xs text-muted-foreground">{user.email}</p>
        <Badge variant="secondary" appearance="soft" size="sm" className="mt-1">
          Directory
        </Badge>
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            aria-label="Actions"
            disabled={isPending}
            className="flex size-8 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-muted cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50"
          >
            {isPending ? <Spinner className="size-4" /> : <MoreHorizontal className="size-4" />}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {onAdd && (
            <>
              <DropdownMenuItem onClick={onAdd}>
                <UserCheck className="size-4" /> Add
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          )}
          <DropdownMenuItem onClick={onInvite}>
            <Mail className="size-4" /> Invite
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
